import ConfigProvider, { ConfigContext } from './ConfigProvider';

export default ConfigProvider;
export {
    ConfigContext,
};
